export * from "ce/selectors/aiAgentSelectors";

import { FEATURE_FLAG } from "ee/entities/FeatureFlag";
import type { DefaultRootState } from "react-redux";
import { selectFeatureFlagCheck } from "ce/selectors/featureFlagsSelectors";
import { createSelector } from "reselect";
import type { ActionDataState } from "ee/reducers/entityReducers/actionsReducer";
import { PluginPackageName, type Plugin } from "entities/Plugin";
import { getActions, getPluginByPackageName } from "./entitiesSelector";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getIsAiAgentFlowEnabled = (state: DefaultRootState) => {
  return selectFeatureFlagCheck(state, FEATURE_FLAG.license_ai_agent_enabled);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getIsAiAgentInstanceEnabled = (state: DefaultRootState) => {
  return selectFeatureFlagCheck(
    state,
    FEATURE_FLAG.license_ai_agent_instance_enabled,
  );
};

export const getIsNewUserFlowEnabled = (state: DefaultRootState) => {
  return state.entities.aiAgents.isNewUserFlowEnabled;
};

export const getAgentChatQueries = createSelector(
  (state: DefaultRootState) =>
    getPluginByPackageName(state, PluginPackageName.APPSMITH_AGENT),
  getActions,
  (plugin: Plugin | undefined, actions: ActionDataState) => {
    if (!plugin) return [];

    return actions.filter(
      (action) =>
        action.config.pluginId === plugin.id &&
        action.config.actionConfiguration.formData.usecase.data ===
          "AI_CHAT_ASSISTANT",
    );
  },
);

export const getSelectedIntegrationType = (state: DefaultRootState) => {
  return state.entities.aiAgents.selectedIntegrationType;
};

export const getIsAiAgentApp = createSelector(
  getAgentChatQueries,
  (queries) => queries.length > 0,
);

export const getIsCreatingAgent = (state: DefaultRootState) => {
  return state.entities.aiAgents.isCreatingAgent;
};

export const getAgentChatQuery = (actionId: string) =>
  createSelector(getAgentChatQueries, (queries) =>
    queries.find((query) => query.config.id === actionId),
  );

export const getIsSupportModalOpen = (state: DefaultRootState) => {
  return state.entities.aiAgents.isSupportModalOpen;
};

export const getIsCreateAgentModalOpen = (state: DefaultRootState) => {
  return state.entities.aiAgents.isCreateAgentModalOpen;
};
